import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { keyMap } from '@locales/lokalise/keyMap';

const trimToLastForwardslash = (url: string): string => {
  const str = url[url.length - 1] === '/' ? url.slice(0, -1) : url;
  const lastSlashIndex = str.lastIndexOf('/');

  return lastSlashIndex !== -1 ? str.substring(0, lastSlashIndex) : str;
};

interface INavButtonsProps {
  onClick?: () => void;
  backPath?: string;
}

export const useGoBackNavigation = (backPath?: string) => {
  const history = useHistory();
  const isHistoryEmpty = history.length <= 1;

  const goBack = useCallback(() => {
    if (isHistoryEmpty) {
      const { pathname = '/' } = history.location;
      const url = backPath || trimToLastForwardslash(pathname);

      history.push(url);
    } else {
      history.goBack();
    }
  }, [history, backPath, isHistoryEmpty]);

  return {
    goBack,
  };
};

const NavButtons = ({ onClick, backPath }: INavButtonsProps) => {
  const { i18n } = useTranslation();

  const { goBack } = useGoBackNavigation(backPath);

  return (
    <div className="content__header-right">
      <div className="btn-group">
        <button
          type="button"
          className="btn btn--back"
          onClick={() => {
            if (!onClick) {
              return goBack();
            }

            return onClick();
          }}>
          {i18n.t(keyMap.sharedActionsBack)}
        </button>
      </div>
    </div>
  );
};

export default NavButtons;
